import React from 'react';
import { Skeleton } from '@mui/material';

const LoadingState = () => {
  const styles = {
    container: {
      backgroundColor: '#f8f9fa',
      minHeight: '500px',
      padding: '20px'
    },
    tabContainer: {
      display: 'flex',
      marginBottom: '20px',
      backgroundColor: '#f8f9fa',
      padding: '4px',
      borderRadius: '8px',
      border: '1px solid #dee2e6',
      gap: '4px'
    },
    tab: {
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: '500',
      border: 'none',
      borderRadius: '6px',
      backgroundColor: '#007bff',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      minWidth: '120px',
      justifyContent: 'center'
    },
    table: {
      width: '100%',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      border: '1px solid #e9ecef'
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #e9ecef',
      fontWeight: '600',
      fontSize: '13px',
      color: '#495057'
    },
    headerCell: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      whiteSpace: 'nowrap',
      lineHeight: '1.2'
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      borderBottom: '1px solid #f8f9fa'
    },
    carrierColumn: {
      flex: '1',
      minWidth: '250px',
      display: 'flex',
      flexDirection: 'column'
    },
    actionColumn: {
      flex: '0 0 280px',
      textAlign: 'center',
      display: 'flex',
      gap: '8px',
      justifyContent: 'center',
      alignItems: 'center'
    },
    dataColumn: {
      flex: '0 0 140px',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: '500',
      color: '#333'
    }
  };

  // Create skeleton row component
  const renderSkeletonRow = index => (
    <div key={`skeleton-${index}`} style={styles.row}>
      {/* Carrier/Product Column */}
      <div style={styles.carrierColumn}>
        <Skeleton variant='text' width='80%' height={20} style={{ marginBottom: '4px' }} />
        <Skeleton variant='text' width='60%' height={16} />
      </div>

      {/* Data Columns */}
      <div style={styles.dataColumn}>
        <Skeleton variant='text' width='70%' height={20} style={{ margin: '0 auto' }} />
      </div>
      <div style={styles.dataColumn}>
        <Skeleton variant='text' width='70%' height={20} style={{ margin: '0 auto' }} />
      </div>
      <div style={styles.dataColumn}>
        <Skeleton variant='text' width='70%' height={20} style={{ margin: '0 auto' }} />
      </div>
      <div style={styles.dataColumn}>
        <Skeleton variant='text' width='70%' height={20} style={{ margin: '0 auto' }} />
      </div>

      {/* Actions Column */}
      <div style={styles.actionColumn}>
        <Skeleton variant='rectangular' width={60} height={24} style={{ borderRadius: '4px' }} />
        <Skeleton variant='rectangular' width={80} height={32} style={{ borderRadius: '4px' }} />
        <Skeleton variant='rectangular' width={90} height={32} style={{ borderRadius: '4px' }} />
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      {/* Loading Tab */}
      <div style={styles.tabContainer}>
        <div style={styles.tab}>
          <Skeleton variant='text' width={120} height={16} style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
          <Skeleton variant='rectangular' width={24} height={16} style={{ borderRadius: '12px', backgroundColor: 'rgba(255,255,255,0.3)' }} />
        </div>
      </div>

      {/* Loading Table */}
      <div style={styles.table}>
        {/* Header Row with Skeleton */}
        <div style={styles.headerRow}>
          {/* Carrier/Product Header */}
          <div style={{ ...styles.headerCell, flex: '1', minWidth: '250px' }}>
            <Skeleton variant='text' width={120} height={16} />
          </div>

          {/* Data Column Headers */}
          <div style={{ ...styles.headerCell, flex: '0 0 140px', justifyContent: 'center' }}>
            <Skeleton variant='text' width={100} height={16} style={{ margin: '0 auto' }} />
          </div>
          <div style={{ ...styles.headerCell, flex: '0 0 140px', justifyContent: 'center' }}>
            <Skeleton variant='text' width={110} height={16} style={{ margin: '0 auto' }} />
          </div>
          <div style={{ ...styles.headerCell, flex: '0 0 140px', justifyContent: 'center' }}>
            <Skeleton variant='text' width={90} height={16} style={{ margin: '0 auto' }} />
          </div>
          <div style={{ ...styles.headerCell, flex: '0 0 140px', justifyContent: 'center' }}>
            <Skeleton variant='text' width={120} height={16} style={{ margin: '0 auto' }} />
          </div>

          {/* Actions Header */}
          <div style={{ ...styles.headerCell, flex: '0 0 280px', justifyContent: 'center' }}>
            <Skeleton variant='text' width={60} height={16} style={{ margin: '0 auto' }} />
          </div>
        </div>

        {/* Skeleton Rows */}
        {Array.from({ length: 10 }, (_, index) => renderSkeletonRow(index))}
      </div>
    </div>
  );
};

export default LoadingState;
